var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('nav-bar'),_c('div',{staticClass:"main"},[_c('banner'),_c('team-member'),_c('contact',{attrs:{"is-gray":true}}),_c('clients'),_c('subscribe'),_c('site-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }